import React, { Component } from 'react'

import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import * as Sentry from '@sentry/react'

import withStripeProvider from './components/hocs/withStripeProvider'
import IEBlocker from './components/ui/environment/IEBlocker'
import Routes from './routes/Routes'
import store, { persist } from './store/configureStore'
import errorService from './utils/analytics/error'
import application from './utils/constants/application'
import routerHistory from './utils/routing/history'
import ErrorPage from './components/ui/errorPage/ErrorPage'
import * as FullStory from '@fullstory/browser'

const orgId = process.env.REACT_APP_FULLSTORY_ORGID

export class App extends Component {
  constructor(props) {
    super(props)
    FullStory.init({ orgId })

    this.state = {
      rehydrated: false,
    }
  }

componentWillMount() {
    import('./assets/lottieSources/graduate.json').then(data => {
      window.graduateLottie = data
    })
}

  componentDidMount() {
    persist().then(() => {
      this.setState({ rehydrated: true })
      errorService.configure()
    })
  }

  render() {
    const { rehydrated } = this.state

    if (!rehydrated) return null

    if (application.isLowerThanIE11) return <IEBlocker />

    return (
      <Provider store={store}>
        <ConnectedRouter history={routerHistory}>
          <Sentry.ErrorBoundary fallback={() => <ErrorPage />}>
            <Routes />
          </Sentry.ErrorBoundary>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default Sentry.withProfiler(withStripeProvider(App), { name: 'DCC' })



// WEBPACK FOOTER //
// ./src/App.js